export const MyOperationRouting = [
  {
    path: "/maintenance/myOperation",
    name: "maintenance-myOperation-list",
    meta: { title: "我的运维任务" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-myOperation" */ "@/views/maintenance/myOperation/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/myOperation/detail/:id",
    name: "maintenance-myOperation-detail",
    meta: { title: "我的运维任务详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-myOperation" */ "@/views/maintenance/myOperation/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/myOperation/flowPrint/:id",
    name: "maintenance-myOperation-flow-print",
    meta: { title: "我的运维任务打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-myOperation" */ "@/views/maintenance/myOperation/flow-print/index.vue"
      ),
  },
];
